import { pluck } from 'underscore';

import { getCurrentCompany, getCurrentUser } from '@bonusly/who-am-i';

import { RichMediaState } from './state';

export const fetchAmounts = async ({ query }: { query: string }) => {
	const user = await getCurrentUser();
	const balance = user.giving_balance + user.flash_points_balance;

	if (!user.suggested_give_amounts) {
		return [];
	}

	const values = pluck(user.suggested_give_amounts, 'dataValue');

	return values.filter(Boolean).filter((value) => {
		if (!value && !balance) {
			return true;
		}

		if (query) {
			return value.toString().includes(query);
		}

		return value > 0 && value <= balance;
	});
};

export const fetchHashtags = async ({ query, state }: { query: string; state: RichMediaState }) => {
	const company = await getCurrentCompany();

	return company.company_hashtags
		.map((hashtag) => hashtag.slice(1))
		.filter((hashtag) => !state.hashtags.includes(hashtag) && new RegExp(query, 'i').test(hashtag));
};
